import common from './common';
import customer from './customer';
import storageSystem from './storageSystem';
import solarPanel from './solarPanel';
import listFields from './listFields';
import inverter from './inverter'; // @deprecated
import inverter1 from './inverter1'; // @deprecated
import inverter2 from './inverter2'; // @deprecated
import inverterCommon from './inverterCommon';
import battery from './battery';
import batteryOld from './batteryOld';
import enfluri from './enfluri';
import enfluriOld from './enfluriOld';
import wallbox from './wallbox';
import extendedConfiguration from './extendedConfiguration';
import electrician from './electrician';
import powerCompany from './powerCompany';

const solarPlant = {
  key: '1',
  label: 'solarPlant',
  children: [
    battery,
    enfluri,
    solarPanel,
    wallbox,
    inverterCommon,
    { ...listFields.inverters },
    { ...listFields.solarPanels },
    inverter1,
    inverter2,
    extendedConfiguration,
    batteryOld,
    enfluriOld,
    storageSystem,
    inverter,
  ],
};

const documentFieldDefinitions = [common, customer, solarPlant, electrician, powerCompany];

export default documentFieldDefinitions;
